
import { MassActionTypes } from './mass.types';
import { extractTypes, extractGeneration } from './mass.util';


const INITIAL_STATE = {
    masses: [],
    types: [],
    gen: 1, 
    isFetching: true,
    errorMessage: undefined
};

const massReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case MassActionTypes.UPDATE_MASSES:
            return {
                ...state, 
                isFetching: false,
                masses: action.payload
            };

        case MassActionTypes.UPDATE_CONFIG:
            return {
                ...state,
                types: extractTypes(action.payload, state.types),
                gen: extractGeneration(action.payload, state.gen)
            };
        

        default:
            return state;
    }
};

export default massReducer;